import { atom, useRecoilValue, useSetRecoilState } from 'recoil';

type Banner = {
    slug: string;
    size?: {
        width: string;
        height: string;
    };
    text: string;
};

type BannersGroup = {
    title: string;
    list: Banner[];
};

const currentBannersState = atom<BannersGroup[]>({
    key: 'currentBannersState',
    default: [],
});

export const useCurrentBannersStateValue = () => useRecoilValue(currentBannersState);
export const useSetCurrentBannersState = () => useSetRecoilState(currentBannersState);

const activeBannerState = atom<string>({
    key: 'activeBannerState',
    default: '',
});

export const useActiveBannerStateValue = () => useRecoilValue(activeBannerState);
export const useSetActiveBannersState = () => useSetRecoilState(activeBannerState);
